<!--<div class="container-fluid">-->
<div >
  <app-property-search-header [recordCount]="propSearchGrid.recordCount"></app-property-search-header>
</div>
<div >
  <app-property-search-grid></app-property-search-grid>
</div>
<!--</div>-->
